
























import { computed, defineComponent } from "@vue/composition-api";
import { CalendarEvent, google, ics } from "calendar-link";
import { format } from "date-fns";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import { $t } from "@/lib/i18nHelpers";
import saveFile from "@/lib/saveFileHelper";
import { BaseMenuItem } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "AppointmentAddToCalendarConfirm",
  components: { BaseConfirm, BaseButton, BaseIcon },
  props: {
    show: { type: Boolean, required: true },
    appointment: { type: Object as () => Appointment | null, default: null },
    authUserId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const buttons = computed<BaseMenuItem[]>(() => [
      {
        name: "google",
        text: $t("Google"),
        prependIcon: "sci-color-g-calendar",
      },
      {
        name: "apple",
        text: $t("Apple"),
        prependIcon: "sci-color-apple",
      },
    ]);

    const addToCalendar = (type: "google" | "apple") => {
      if (!props.appointment) return;

      const startTime = props.appointment.startTime;
      const endTime = props.appointment.endTime;
      const appointmentType = props.appointment.typeKind.toLowerCase().replace("_", " ");
      const opponentScreenname =
        props.authUserId === props.appointment.providerId
          ? props.appointment.consumer.screenName
          : props.appointment.provider.screenName;

      const event: CalendarEvent = {
        start: startTime,
        end: endTime,
        title: `Appointments with ${opponentScreenname}`,
        description: `${appointmentType.charAt(0).toUpperCase() +
          appointmentType.slice(1)} booked with ${opponentScreenname} for $${props.appointment.amount}`,
        busy: true,
      };

      const data = type === "google" ? google(event) : ics(event);
      const name =
        $t("Appointments with {0} {1}", [
          opponentScreenname,
          format(new Date(props.appointment.startTime), "yyyy-MM-dd"),
        ]) + ".ics";
      saveFile({ href: data, name });
      emit("close");
    };

    return {
      buttons,
      addToCalendar,
    };
  },
});
